import { Badge } from '@bbpos/ui';
import type { BadgeSize } from '@bbpos/ui';
import type { TransferStatus } from './types';

interface StatusMeta {
  label: string;
  variant: 'pending' | 'inTransit' | 'transferCompleted' | 'partial' | 'received' | 'transferRejected' | 'cancelled';
}

const STATUS_MAP: Record<TransferStatus, StatusMeta> = {
  PENDING:    { label: 'Pending',    variant: 'pending' },
  IN_TRANSIT: { label: 'In Transit', variant: 'inTransit' },
  PARTIALLY_RECEIVED: { label: 'Partially Received', variant: 'partial' },
  COMPLETED:  { label: 'Completed',  variant: 'transferCompleted' },
  PARTIALLY_ACCEPTED: { label: 'Partially Accepted', variant: 'partial' },
  RECEIVED:   { label: 'Received',   variant: 'received' },
  REJECTED:   { label: 'Rejected',   variant: 'transferRejected' },
  CANCELLED:  { label: 'Cancelled',  variant: 'cancelled' },
};

export interface TransferStatusBadgeProps {
  status: TransferStatus;
  size?: BadgeSize;
}

export function TransferStatusBadge({ status, size = 'sm' }: TransferStatusBadgeProps) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.PENDING;
  return (
    <Badge variant={meta.variant} size={size} dot>
      {meta.label}
    </Badge>
  );
}
